var _path, _line, _line2, _line3, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUnselectedShowcaseDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 52,
    viewBox: "0 0 24 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1032 20.817C11.4701 20.0737 12.5299 20.0737 12.8967 20.817L14.9873 25.0531C15.133 25.3482 15.4146 25.5528 15.7403 25.6001L20.4151 26.2794C21.2353 26.3986 21.5628 27.4066 20.9693 27.9851L17.5866 31.2824C17.3509 31.5122 17.2433 31.8432 17.299 32.1676L18.0975 36.8235C18.2376 37.6404 17.3802 38.2633 16.6466 37.8777L12.4653 35.6794C12.174 35.5263 11.826 35.5263 11.5346 35.6794L7.35337 37.8777C6.61974 38.2633 5.76231 37.6404 5.90242 36.8235L6.70097 32.1676C6.75661 31.8432 6.64906 31.5122 6.41337 31.2824L3.03066 27.9851C2.43714 27.4066 2.76465 26.3986 3.58487 26.2794L8.25967 25.6001C8.58538 25.5528 8.86695 25.3482 9.01261 25.0531L11.1032 20.817Z",
    fill: "#5C5B68"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.72205,
    y1: 22.6521,
    x2: 4.20024,
    y2: 21.1303,
    stroke: "#5C5B68",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 2.90217,
    y2: -0.75,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 17.2173 22.6521)",
    stroke: "#5C5B68",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 2.90217,
    y2: -0.75,
    transform: "matrix(0 -1 -1 0 11.2173 41.9565)",
    stroke: "#5C5B68",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 2.90217,
    y2: -0.75,
    transform: "matrix(0.906308 -0.422618 -0.422618 -0.906308 0 34.2323)",
    stroke: "#5C5B68",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 23.0033,
    y1: 34.5951,
    x2: 21.0528,
    y2: 33.6855,
    stroke: "#5C5B68",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnselectedShowcaseDark);
export default __webpack_public_path__ + "static/media/ic_unselected_showcase_dark.01270e131d3d5c35b6be50d5fdcd171f.svg";
export { ForwardRef as ReactComponent };